module.exports = __webpack_public_path__ + "img/info_11.37b4b4bb.jpeg";